// src/admin/AdminLogin.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../firebase/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch {
      setError("Invalid email or password. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <img src="/logo-dark.png" alt="Mother Child Empowerment Initiative" />
        <h2>Admin Portal</h2>
        <p>Sign in to manage your website content</p>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleSubmit} style={{ display:"flex", flexDirection:"column", gap:"1rem" }}>
          <div className="admin-field"><label>Email Address</label><input type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@motherchild.org" /></div>
          <div className="admin-field"><label>Password</label><input type="password" required value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" /></div>
          <button className="admin-btn admin-btn-primary" type="submit" disabled={loading} style={{ width:"100%", justifyContent:"center", padding:"0.75rem", fontSize:"0.95rem" }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p style={{ textAlign:"center", marginTop:"1.5rem", fontSize:"0.8rem", color:"#64748B" }}>
          <a href="/" style={{ color:"var(--purple)" }}>← Back to website</a>
        </p>
      </div>
    </div>
  );
}
